import React from "react";
import CustomTooltip from "components/CustomTooltip";
import "./styles.scss";

export const InfoTooltip = ({ content }) => (
  <CustomTooltip
    title={
      <div className="info-tooltip-content-bootstrap">
        {content}
      </div>
    }
    placement="auto"
    arrow
    enterTouchDelay={0}
  >
    <span className="info-tooltip-icon">
      <i className="bi bi-info-fill">i</i>
    </span>
  </CustomTooltip>
);

export const tooltipContent = (
  <div>
    <strong>Selecione o intervalo</strong>
    <hr />
    <div>
      <strong>Hoje:</strong> Aplica um filtro relativo à data atual
    </div>
    <div>
      <strong>Dias à frente:</strong> Exibe campo "Próximos [...] dias" a partir
      da data atual, progressivamente
    </div>
    <div>
      <strong>Dias passados:</strong> Exibe campo "Últimos [...]dias" a partir
      da data atual, mas regressivamente
    </div>
    <div>
      <strong>Intervalo personalizado:</strong> Aplica um filtro personalizado em
      quantidades de dias a partir e até da data atual
    </div>
  </div>
);
